import PuriImage from "../../assets/puri.png"
export default function IconPURI() {
  return (
    <img src={PuriImage} alt="PURI" width="18" height="18" />
  )
}